export const imdWizardStep1 = {
  headingText: 'Era uppgifter för kalkylen',
  yourBuilding: {
    headingText: 'Er bostadsrättsförening',
    amountBuildings: {
      label: 'Antal fastighetsabonnemang för elnät',
      id: 'idAntalByggnader'
    },
    amountApartments: {
      amountApartmentsLabels: [
        {
          label: 'Antal lägenheter inom fastighetsabonnemang',
          id: 'idAntalLagenheter'
        }
      ],
      modalContent: {
        description: `Har ni en lokal som har liknande energianvändning som en lägenhet kan ni inkludera den i antalet lägenheter.`,
        showImage: false,
        modalWindowSizeLarge: false
      }
    }
  },
  yourOffer: {
    headingText: 'Er offert för IMD el',
    investmentcostImd: {
      investmentcostImdLabels: [
        {
          label: 'Investeringskostnader för IMD (ink. moms)',
          id: 'idInvestmentCostImd'
        }
      ],
      modalContent: {
        description: `Med investeringskostnad menas engångskostnaden för exempelvis installation av utrustning och eventuell anpassning av elcentral.`,
        showImage: false,
        modalWindowSizeLarge: false
      }
    },
    operatingCostPerApartment: {
      operatingCostPerApartmentLabels: [
        {
          label: 'Driftskostnad per lägenhet per månad (ink. moms)',
          id: 'idOperatingCostImd'
        }
      ],
      modalContent: {
        description: `Med driftkostnad menas löpande kostnader för drift och underhåll, som insamling av mätvärden, underhåll av elmätare och mätsystem etc.`,
        showImage: false,
        modalWindowSizeLarge: false
      }
    }
  },
  stepNavigation: {
    nextButtonText: 'Nästa',
    previousButtonText: 'Tillbaka'
  }
}

export const imdWizardStep2 = [
  {
    Id: 1,
    InputType: 'itemSelectedBox',
    Title: 'Permanent avslut av elanläggning',
    Description: `Vid permanent avslut debiteras en kostnad om 950kr per lägenhet.`,
    descriptionCalculatedValue: true,
    modalContent: {
      heading: 'Permanent avslut av elanläggning',
      description: `Kostnaden avser nedtagning av mätare, avläsning och rapportering av mätvärden, avslut till elhandlaren, transport, lagerhantering och rekonditionering av mätare. Kostnaden är 950 kr per lägenhet.`,
      image: {
        url: 'frame_25655.png',
        altText: 'Utsikt på bostadshus och Globen vid horisonten.'
      }
    },
    disableToggleSwitch: true
  },
  {
    Id: 2,
    InputType: 'itemSelectedBox',
    Title: 'Kostnad för elnät och elhandel',
    Description: `Vid övergång till IMD för el krävs ofta ett större elnätsabonnemang. I denna beräkning antar vi att elanvändningen följer genomsnittliga mönster för lägenheter i Ellevios elnät.`,
    descriptionCalculatedValue: true,
    modalContent: {
      heading: 'Kostnad för elnät och elhandel',
      description: `
      <h4 class="normal-case text-lg">Abonnemang för elnätet</h4>
      <p>Kalkylatorn utgår från effektabonnemanget L04L, vilket oftast är det mest kostnadseffektiva alternativet för bostadsrättsföreningar med IMD. Det beror på att elanvändningen vanligtvis ökar vid IMD och kräver en huvudsäkring större än 63 A.</p>
      <p class="mb-6">Beräkningen baseras på det antal fastighetsabonnemang ni har angett. Energiskatt ingår inte i kalkylen.</p>
      <h4 class="normal-case text-lg">Energikostnader</h4>
      <p>Kostnader för elnät och elhandel beräknas utifrån genomsnittliga priser. Inom elhandel så tar kalkylen enbart hänsyn till genomsnittliga priser för fasta avgifter, inte rörliga. För elnätskostnader antar vi att elanvändningen följer genomsnittliga mönster för lägenheter i Ellevios elnät.</p>
      <p>Beräkningen tar inte hänsyn till bostadsrättsföreningens nuvarande elnätsabonnemang eller befintliga elanvändning, vilket kan påverka de faktiska kostnaderna. Om föreningen har stora elförbrukare utanför lägenheterna (t.ex. restauranger eller värmepumpar) som använder mycket el på andra tider än boende (t.ex. dagtid) kan IMD leda till lägre effekttoppar och därmed lägre nätavgifter.</p>
      `,
      image: {
        url: 'frame_25655.png',
        altText: 'Utsikt på bostadshus och Globen vid horisonten.'
      }
    },
    disableToggleSwitch: true
  },
  {
    Id: 3,
    InputType: 'itemSelectedBox',
    Title: 'Investeringskostnad för IMD enligt offert',
    Description: `Värdet är hämtat från ”Er offert” under steg 1 i kalkylen, men beloppet kan justeras här.`,
    // modalContent: {
    //   heading: 'Investeringskostnader för IMD',
    //   description: `Lorem ipsum`,
    //   image: {
    //     url: 'varmeatervinning_468x505.jpg',
    //     altText: 'Bild på ett rött hus.'
    //   }
    // },
    slot: {
      id: 3,
      inputKey: 'investmentcost',
      type: 'integerNumbers',
      labels: [
        {
          label: 'Investeringskostnader för IMD (ink. moms)',
          id: 'idInvestmentCostImd'
        }
      ],
      suffix: 'kr',
      defaultValue: {
        response: '0'
      }
    },
    toggleSwitch: true,
    disableToggleSwitch: true
  },
  {
    Id: 4,
    InputType: 'itemSelectedBox',
    Title: 'Driftskostnad',
    Description: `Löpande kostnad för drift och underhåll. Värdet är hämtat från ”Er offert” under steg 1 i kalkylen, men beloppet kan justeras här.`,
    modalContent: {
      heading: 'Driftskostnad',
      description: `Med driftskostnad menas löpande kostnader för drift och underhåll, som insamling av mätvärden, underhåll av elmätare och mätsystem etc.`,
      image: {
        url: 'frame_25655.png',
        altText: 'Utsikt på bostadshus och Globen vid horisonten.'
      }
    },
    slot: {
      id: 4,
      inputKey: 'operatingcosts',
      type: 'integerNumbers',
      labels: [
        {
          label: 'Kostnad per lägenhet per månad (ink. Moms)',
          id: 'idDriftskostnad'
        }
      ],
      suffix: 'kr',
      defaultValue: {
        response: '0'
      }
    },
    toggleSwitch: true,
    disableToggleSwitch: true
  },
  {
    Id: 5,
    inputKey: 'meterReinvestmentPerApartment',
    valueLabel: 'yearsUntilChange',
    InputType: 'counterInput',
    Input: 'År till mätarbyte',
    Title: 'Framtida elmätarbyte',
    Description: 'De nya mätarna kommer att behöva bytas ut efter ett visst antal år. Värdena kan justeras efter era förutsättningar.',
    maxValue: 100,
    defaultValue: {
      response: 10
    },
    modalContent: {
      heading: 'Framtida elmätarbyte',
      description: `Den här posten avser kostnaden för att byta ut elmätare när de gamla behöver ersättas. Kostnaden delas upp på antalet år som mätaren förväntas hålla.
      <br><br>
      Exempel: Om en mätare kostar 2 000 kr och har en livslängd på 10 år, blir kostnaden för återinvesteringen 200 kr per år och lägenhet. Vi rekommenderar att föreningen inkluderar kostnader kommande mätarbyten i sin underhållsplan.`,
      image: {
        url: 'frame_25655.png',
        altText: 'Utsikt på bostadshus och Globen vid horisonten.'
      }
    },
    slot: {
      id: 5,
      inputKey: 'costPerChange',
      type: 'integerNumbers',
      labels: [
        {
          label: 'Kostnad per mätare (ink. moms)',
          id: 'idKostnadPerMatare'
        }
      ],
      suffix: 'kr',
      defaultValue: {
        response: '2000'
      }
    },
    toggleSwitch: true
  },
  {
    Id: 6,
    inputKey: 'interest',
    valueLabel: 'loanTermInYears',
    InputType: 'counterInput',
    Input: 'Avbetalningstid',
    Title: 'Räntekostnad',
    maxValue: 100,
    defaultValue: {
      response: 10
    },
    Description: 'Om investeringen ska belånas, fyll i avbetalningstid och avtalad ränta.',
    // modalContent: {
    //   heading: 'Stäng av golvvärmen',
    //   description:
    //     'Golvvärme kan dra en betydande mängd energi under året. Generellt brukar en kvadratmeter el-golvvärme förbruka mellan 150-300 kWh per år. För ett badrum på 8 kvadratmeter motsvarar det en årlig förbrukning på 1 200-2 400 kilowattimmar. Att stänga av den är alltså ett sätt att spara på elanvändningen.',
    //   image: {
    //     url: 'sank_golvvarme_468x505.jpg',
    //     altText: 'Bild på en hand som ställer in en termostat.'
    //   }
    // },
    slot: {
      id: 6,
      inputKey: 'rate',
      type: 'decimalNumbers',
      labels: [
        {
          label: 'Ränta',
          id: 'idRanta'
        }
      ],
      suffix: '%',
      defaultValue: {
        response: '3'
      }
    },
    toggleSwitch: true
  },
  {
    Id: 7,
    InputType: 'itemSelectedBox',
    Title: 'Administrationskostnad',
    Description: `T.ex. administration för att hantera & driva systemet. Eventuell tredjepartsleverantör som hanterar mätning & fakturering. Det förifyllda beloppet är ett uppskattat värde, men ni kan justera efter era förutsättningar.`,
    // modalContent: {
    //   heading: 'Administrationskostnader',
    //   description: `Kostnaden täcker administration och hantering vid permanent avslut av elanläggning.
    //   <br>
    //   <br>
    //     De mest kompletta system är så kallade FTX-system som kan bespara dig mellan 50-80 % av energin för att värma upp ditt hus, alltså ungefär 5000 kWh. `,
    //   image: {
    //     url: 'varmeatervinning_468x505.jpg',
    //     altText: 'Bild på ett rött hus.'
    //   }
    // },
    slot: {
      id: 7,
      inputKey: 'administrationCostPerApartmentAndMonth',
      type: 'integerNumbers',
      labels: [
        {
          label: 'Kostnad per lägenhet per månad (ink. moms)',
          id: 'idKostnadPerLagenhetPerManad'
        }
      ],
      suffix: 'kr',
      defaultValue: {
        response: '0'
      }
    },
    toggleSwitch: false
  },
  {
    Id: 8,
    InputType: 'itemSelectedBox',
    Title: 'Övriga kostnader',
    Description: `Här kan du fylla i kostnader som inte täcks inom övriga fält. Det kan till exempel vara eventuella kostnader mot tredjepartsleverantör som hanterar fakturering.`,
    // modalContent: {
    //   heading: 'Övriga kostnader',
    //   description: `Här kan du fylla i kostnader som inte täcks inom övriga fält. Det kan till exempel vara eventuella kostnader mot tredjepartsleverantör som hanterar fakturering.`,
    //   image: {
    //     url: 'varmeatervinning_468x505.jpg',
    //     altText: 'Bild på ett rött hus.'
    //   }
    // },
    slot: {
      id: 8,
      inputKey: 'otherCosts',
      type: 'integerNumbers',
      labels: [
        {
          label: 'Total kostnad per månad (ink. moms)',
          id: 'idTotalKostnadPerAr'
        }
      ],
      suffix: 'kr',
      defaultValue: {
        response: null
      }
    }
  }
]

export const translations = {
  imdWizardStep2: {
    headingText: 'Kostnadskalkyl IMD',
    filterYearMonthButton: ['Per månad', 'Per år'],
    summaryCostArea: {
      currentCostText: 'Kostnad per lgh idag:',
      calculatedCostImdText: 'Kostnad per lgh med IMD:',
      costDifferenceText: 'Kostnad per lgh:',
      costDifferenceGainText: 'Minskad kostnad per lgh:',
      costDifferenceLossText: 'Ökad kostnad per lgh:',
      repaymentPeriodText: 'Återbetalningstid för föreningen:'
    },
    howWeCalculated: {
      buttonText: 'Så här har vi räknat',
      modalContent: {
        heading: 'Så här fungerar kalkylatorn för IMD av el',
        description: `
          <p class="text-base mt-3">Den här kalkylatorn hjälper er att få en uppskattning av de ekonomiska effekterna av att införa <strong>individuell mätning och debitering (IMD)</strong> av el i er bostadsrättsförening. Syftet är att ge en överblick över potentiella besparingar – inte exakta siffror.</p>
          <p class="text-base mt-3">Kalkylen baseras på en kombination av kända kostnader, de uppgifter ni själva anger samt generella antaganden om elanvändning och abonnemang.</p>
          <p class="text-base mt-3">Nedan förklarar vi hur vi räknat och vilka antaganden som ligger till grund för kalkylen.</p>

          <h3 class="text-lg normal-case mt-5">1. Lönsamhet för IMD el</h3>
          <p class="text-base">Vi räknar först ut alla kostnader som kan uppstå vid införandet av IMD, exempelvis:</p>
          <ul class="text-base ml-6 list-disc">
          <li><strong>Investeringskostnader:</strong> Kostnaden för att installera elmätare och eventuell ny utrustning.</li>
          <li><strong>Löpande kostnader:</strong> Administration, drift och underhåll, räntekostnader.</li>
          <li><strong>Avslutningskostnader:</strong> Avgifter för att permanent avsluta enskilda elnätsabonnemang.</li>
          <li><strong>Kostnader för elnät och elhandel:</strong> För bostadsrättsföreningen som helhet.</li>
          <li><strong>Framtida elmätarbyte:</strong> Byte av elmätare när deras livslängd löper ut.</li>
          </ul>
          <p class="text-base mt-5">Den totala kostnaden för IMD fördelas ut per lägenhet och jämförs sedan med nuvarande kostnader för de individuella abonnemangen.</p>

          <h3 class="text-lg normal-case mt-5">2. Beräkning av återbetalningstid</h3>
          <p class="text-base">För att ta reda på hur lång tid det tar innan investeringen lönar sig gör vi följande beräkning:</p>
          <ol class="text-base list-decimal ml-6">
          <li>Vi jämför de årliga kostnaderna för  <strong>nuvarande elnätsabonnemang</strong> med de årliga kostnaderna för <strong>IMD</strong>.</li>
          <li>Vi beräknar besparingen per år genom att ta skillnaden mellan dessa två kostnader.</li>
          <li>Vi delar den totala investeringskostnaden med den årliga besparingen - det ger oss en uppskattning av <strong>återbetalningstiden</strong>.</li>
          </ol>
          <p class="text-base mt-5">Exempel:</p>
          <ul class="text-base ml-6 list-disc">
          <li>Kostnad för individuella abonnemang per år: 150 000 kr</li>
          <li>Kostnad för IMD per år: 130 000 kr</li>
          <li>Årlig besparing: 20 000 kr</li>
          </ul>
          <p class="text-base mt-5">Om investeringen kostar <strong>200 000 kr:</strong> <strong>200 000 / 20 000 = 10 år</strong> (återbetalningstid)</p>

          <h3 class="text-lg normal-case mt-5">3. Kostnad för elnät och elhandel</h3>

          <h4 class="text-base normal-case mt-5">Abonnemang för elnätet</h4>
          <p class="text-base">Kalkylatorn utgår från <strong>effektabonnemanget L04L</strong>, vilket oftast är det mest kostnadseffektiva alternativet för bostadsrättsföreningar med IMD. Det beror på att elanvändningen vanligtvis ökar vid IMD och kräver en huvudsäkring större än 63 A. Alternativet <strong>L04S</strong> har en hög fast avgift och blir endast lönsamt vid mycket hög elanvändning.</p>
          <p class="text-base mt-5">Beräkningen baseras på det antal fastighetsabonnemang ni har angett. Energiskatt ingår inte i kalkylen.</p>

          <h4 class="text-base normal-case mt-5">Energikostnader</h4>
          <p class="text-base">Kostnader för <strong>elnät och elhandel</strong> beräknas utifrån genomsnittliga priser. Inom elhandel så tar kalkylen enbart hänsyn till genomsnittliga priser för fasta avgifter, inte rörliga. För elnätskostnader antar vi att elanvändningen följer genomsnittliga mönster för lägenheter i Ellevios elnät:</p>
          <ul class="text-base ml-6 list-disc">
          <li>30 % av elanvändningen sker under höglasttid (när elnätet är mest belastat och el ofta är dyrare)</li>
          <li>70 % av elanvändningen sker under låglasttid (när elnätet är mindre belastat och elen ofta är billigare)</li>
          </ul>
          <p class="text-base mt-5">När flera lägenheter delar på ett gemensamt abonnemang används elen mer jämnt över tid. Alla i fastigheten använder inte el samtidigt, vilket sänker den totala effekten och därmed även vissa kostnader. Kalkylatorn räknar med ett genomsnitt baserat på elanvändningen i Ellevios elnät.</p>

          <h4 class="text-base normal-case mt-5">Viktigt att veta:</h4>
          <p class="text-base">Kalkylen tar <strong>inte</strong> hänsyn till bostadsrättsföreningens nuvarande elnätsabonnemang eller befintliga elanvändning, vilket kan påverka de faktiska kostnaderna. Om föreningen har stora elförbrukare utanför lägenheterna (t.ex. restauranger eller värmepumpar) som använder mycket el på andra tider än boende (t.ex. dagtid) kan IMD leda till lägre effekttoppar och därmed lägre nätavgifter.</p>

          <h3 class="text-lg normal-case mt-5">4. Kalkyllängd</h3>
          <p class="text-base">Kalkylatorn beräknar kostnader och besparingar över en period på 10 år, eftersom det är en vanlig avskrivningstid för teknisk utrustning i bostadsrättsföreningar, inklusive elmätare. Efter denna period kan kostnaderna förändras.</p>
        `,
        image: {
          url: 'frame_25655.png',
          altText: 'Utsikt på bostadshus och Globen vid horisonten.'
        }
      }
    }
  },
  imdWizardStep3: {
    headingText: 'Er kostnadskalkyl för IMD',
    descriptionText:
      'Här är er sammanfattande kostnadskalkyl för en eventuell övergång till IMD för el. Kalkylen bygger på en kombination av kända kostnader, era egna uppgifter och några generella antaganden. Syftet är att ge en översikt av potentiell lönsamhet snarare än exakta siffror.',
    readMoreAnchorButtonText: 'Vill ni diskutera IMD med en rådgivare?',
    costDifferenceText: 'Kostnad per lägenhet:',
    costDifferenceGainText: 'Minskad kostnad per lgh:',
    costDifferenceLossText: 'Ökad kostnad per lgh:',
    paybackPeriodForInvestment: 'Återbetalningstid av investering för föreningen:',
    imdCostsTable: {
      captionText: 'Kostnader för IMD',
      tableHeaders: {
        allCosts: 'Alla kostnader',
        totalCosts: 'Totalt',
        costPerApartment: 'Per lägenhet'
      },
      costItems: [
        { rowText: 'Investeringskostnad för IMD enligt offert', key: 'investment', unit: 'kr', perApartment: 'kr /mån*', showTotal: true },
        { rowText: 'Permanent avslut av elanläggning', key: 'permanentDisconnection', unit: 'kr', perApartment: 'kr /mån*', showTotal: true },
        { rowText: 'Kostnad för elnät och elhandel', key: 'subscription', unit: 'kr /mån', perApartment: 'kr /mån', showTotal: false },
        { rowText: 'Framtida elmätarbyte**', key: 'meterReinvestment', unit: 'kr /mån', perApartment: 'kr /mån', showTotal: false },
        { rowText: 'Driftskostnad', key: 'operating', unit: 'kr /mån', perApartment: 'kr /mån', showTotal: false },
        { rowText: 'Räntekostnad', key: 'interest', unit: 'kr /mån', perApartment: 'kr /mån', showTotal: false },
        { rowText: 'Administrationskostnad', key: 'admin', unit: 'kr /mån', perApartment: 'kr /mån', showTotal: false },
        { rowText: 'Övriga kostnader', key: 'misc', unit: 'kr /mån', perApartment: 'kr /mån', showTotal: false }
      ],
      depreciationText: '*Räknat över 10 år baserat på branschpraxis för avskrivning av teknisk utrustning.',
      meterLifespanText: '**Räknat på mätarens livslängd på'
    },
    imdTotalCostsTable: {
      captionText: 'Total kostnader per lägenhet',
      tableHeaders: {
        totalCostperApartment: 'Total kostnad per lägenhet',
        costPerMonth: 'Per månad',
        costPerYear: 'Per år'
      },
      costItems: [
        { rowText: 'Med IMD', key: 'totalImd', monthly: 'kr', yearly: 'kr' },
        { rowText: 'Utan IMD', key: 'totalCurrent', monthly: 'kr', yearly: 'kr' }
      ]
    },
    buttonsTexts: {
      editCalculations: 'Redigera',
      downloadPdf: 'Ladda ner',
      copyLink: 'Kopiera länk'
    },
    howWeCalculated: {
      buttonText: 'Så här har vi räknat',
      modalContent: {
        heading: 'Så här fungerar kalkylatorn för IMD av el',
        description: `
          <p class="text-base mt-3">Den här kalkylatorn hjälper er att få en uppskattning av de ekonomiska effekterna av att införa <strong>individuell mätning och debitering (IMD)</strong> av el i er bostadsrättsförening. Syftet är att ge en överblick över potentiella besparingar – inte exakta siffror.</p>
          <p class="text-base mt-3">Kalkylen baseras på en kombination av kända kostnader, de uppgifter ni själva anger samt generella antaganden om elanvändning och abonnemang.</p>
          <p class="text-base mt-3">Nedan förklarar vi hur vi räknat och vilka antaganden som ligger till grund för kalkylen.</p>

          <h3 class="text-lg normal-case mt-5">1. Lönsamhet för IMD el</h3>
          <p class="text-base">Vi räknar först ut alla kostnader som kan uppstå vid införandet av IMD, exempelvis:</p>
          <ul class="text-base ml-6 list-disc">
          <li><strong>Investeringskostnader:</strong> Kostnaden för att installera elmätare och eventuell ny utrustning.</li>
          <li><strong>Löpande kostnader:</strong> Administration, drift och underhåll, räntekostnader.</li>
          <li><strong>Avslutningskostnader:</strong> Avgifter för att permanent avsluta enskilda elnätsabonnemang.</li>
          <li><strong>Kostnader för elnät och elhandel:</strong> För bostadsrättsföreningen som helhet.</li>
          <li><strong>Framtida elmätarbyte:</strong> Byte av elmätare när deras livslängd löper ut.</li>
          </ul>
          <p class="text-base mt-5">Den totala kostnaden för IMD fördelas ut per lägenhet och jämförs sedan med nuvarande kostnader för de individuella abonnemangen.</p>

          <h3 class="text-lg normal-case mt-5">2. Beräkning av återbetalningstid</h3>
          <p class="text-base">För att ta reda på hur lång tid det tar innan investeringen lönar sig gör vi följande beräkning:</p>
          <ol class="text-base list-decimal ml-6">
          <li>Vi jämför de årliga kostnaderna för  <strong>nuvarande elnätsabonnemang</strong> med de årliga kostnaderna för <strong>IMD</strong>.</li>
          <li>Vi beräknar besparingen per år genom att ta skillnaden mellan dessa två kostnader.</li>
          <li>Vi delar den totala investeringskostnaden med den årliga besparingen - det ger oss en uppskattning av <strong>återbetalningstiden</strong>.</li>
          </ol>
          <p class="text-base mt-5">Exempel:</p>
          <ul class="text-base ml-6 list-disc">
          <li>Kostnad för individuella abonnemang per år: 150 000 kr</li>
          <li>Kostnad för IMD per år: 130 000 kr</li>
          <li>Årlig besparing: 20 000 kr</li>
          </ul>
          <p class="text-base mt-5">Om investeringen kostar <strong>200 000 kr:</strong> <strong>200 000 / 20 000 = 10 år</strong> (återbetalningstid)</p>

          <h3 class="text-lg normal-case mt-5">3. Kostnad för elnät och elhandel</h3>

          <h4 class="text-base normal-case mt-5">Abonnemang för elnätet</h4>
          <p class="text-base">Kalkylatorn utgår från <strong>effektabonnemanget L04L</strong>, vilket oftast är det mest kostnadseffektiva alternativet för bostadsrättsföreningar med IMD. Det beror på att elanvändningen vanligtvis ökar vid IMD och kräver en huvudsäkring större än 63 A. Alternativet <strong>L04S</strong> har en hög fast avgift och blir endast lönsamt vid mycket hög elanvändning.</p>
          <p class="text-base mt-5">Beräkningen baseras på det antal fastighetsabonnemang ni har angett. Energiskatt ingår inte i kalkylen.</p>

          <h4 class="text-base normal-case mt-5">Energikostnader</h4>
          <p class="text-base">Kostnader för <strong>elnät och elhandel</strong> beräknas utifrån genomsnittliga priser. Inom elhandel så tar kalkylen enbart hänsyn till genomsnittliga priser för fasta avgifter, inte rörliga. För elnätskostnader antar vi att elanvändningen följer genomsnittliga mönster för lägenheter i Ellevios elnät:</p>
          <ul class="text-base ml-6 list-disc">
          <li>30 % av elanvändningen sker under höglasttid (när elnätet är mest belastat och el ofta är dyrare)</li>
          <li>70 % av elanvändningen sker under låglasttid (när elnätet är mindre belastat och elen ofta är billigare)</li>
          </ul>
          <p class="text-base mt-5">När flera lägenheter delar på ett gemensamt abonnemang används elen mer jämnt över tid. Alla i fastigheten använder inte el samtidigt, vilket sänker den totala effekten och därmed även vissa kostnader. Kalkylatorn räknar med ett genomsnitt baserat på elanvändningen i Ellevios elnät.</p>

          <h4 class="text-base normal-case mt-5">Viktigt att veta:</h4>
          <p class="text-base">Kalkylen tar <strong>inte</strong> hänsyn till bostadsrättsföreningens nuvarande elnätsabonnemang eller befintliga elanvändning, vilket kan påverka de faktiska kostnaderna. Om föreningen har stora elförbrukare utanför lägenheterna (t.ex. restauranger eller värmepumpar) som använder mycket el på andra tider än boende (t.ex. dagtid) kan IMD leda till lägre effekttoppar och därmed lägre nätavgifter.</p>

          <h3 class="text-lg normal-case mt-5">4. Kalkyllängd</h3>
          <p class="text-base">Kalkylatorn beräknar kostnader och besparingar över en period på 10 år, eftersom det är en vanlig avskrivningstid för teknisk utrustning i bostadsrättsföreningar, inklusive elmätare. Efter denna period kan kostnaderna förändras.</p>
        `,
        image: {
          url: 'frame_25655.png',
          altText: 'Utsikt på bostadshus och Globen vid horisonten.'
        }
      }
    }
  }
}
